export type PieChartItem = {
  name: string;
  value: number;
};

const isFlatDataRow = (value: unknown): value is Record<string, unknown> =>
  !!value &&
  typeof value === 'object' &&
  !Array.isArray(value) &&
  Object.values(value).every((entry) => entry === null || typeof entry !== 'object');

const hasPieLabelValue = (value: unknown): value is string | number | boolean =>
  (typeof value === 'string' && value.trim().length > 0) ||
  typeof value === 'number' ||
  typeof value === 'boolean';

const toFiniteNumber = (value: unknown): number | null => {
  if (typeof value === 'number' && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === 'string' && value.trim() !== '') {
    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue : null;
  }

  return null;
};

export const buildPieItems = (
  data: unknown[],
  xKey: string,
  yKey: string,
): PieChartItem[] | null => {
  const items: PieChartItem[] = [];

  for (const row of data) {
    if (!isFlatDataRow(row)) {
      return null;
    }

    const labelValue = row[xKey];
    const numericValue = toFiniteNumber(row[yKey]);

    if (!hasPieLabelValue(labelValue) || numericValue === null) {
      return null;
    }

    items.push({
      name: String(labelValue),
      value: numericValue,
    });
  }

  return items;
};
